import type { IPromiseBasedObservable } from "mobx-utils";
import type { AccountOrg, AccountOrgsSummary } from "@whatslly/types/GetAccountOrgs";
import type { TableSort } from "@whatslly/ui-components/v2/Tables/Table/TableTypes";

export interface IAccountOrganizationsStore {
  // Computed properties
  orgs: IPromiseBasedObservable<AccountOrg[]>;
  summary: AccountOrgsSummary | null;
  sort: TableSort;

  // Methods
  setSort(sort: TableSort): void;
  assignOrgsToAccount(): Promise<void>;
  createAccountOrg(): Promise<void>;
  changeOrgName(org: AccountOrg): Promise<void>;
  removeOrgFromAccount(orgId: string): Promise<void>;
}

export const InjectAccountOrganizationsStore = Symbol.for("AccountOrganizationsStore");
